import React, { Component } from "react";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";
import { Container, Button, Icon, Divider } from "semantic-ui-react";

import { selectCopy } from "../../state/reducers/locale/copySelector.js";

class InvoiceHeader extends Component {
  static propTypes = {
    canViewInvoices: PropTypes.bool.isRequired,
    onPDF: PropTypes.func.isRequired,
    copy: PropTypes.func.isRequired
  };

  static defaultProps = {
    canViewInvoices: true
  };

  render() {
    const { canViewInvoices, onPDF, copy } = this.props;

    if (!canViewInvoices) {
      // need to return an empty Container rather than null here to maintain layout across the site
      return <Container></Container>;
    }

    return (
      <Container>
        <Button
          floated="right"
          icon={true}
          labelPosition="left"
          className="add-project-button"
          onClick={onPDF}
        >
          <Icon name="download" />
          {copy("invoice.download_pdf")}
        </Button>
        <Divider clearing />
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  copy: selectCopy(state)
});

export default connect(mapStateToProps)(InvoiceHeader);
